module.exports = __webpack_public_path__ + "img/1808.db84b23d.gif";